import script from "./MyOptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyOptions.vue?vue&type=script&setup=true&lang=ts"

import "./MyOptions.vue?vue&type=style&index=0&id=14e0b8b6&lang=scss"

const __exports__ = script;

export default __exports__